import "./growth.css";
import './growth.css';
import React from 'react';
import { useLang } from '../../../i18n/context';

const celebrityQuotes = (t) => [
  {
    id: 'buffett',
    name: '沃伦·巴菲特',
    nameEn: 'Warren Buffett',
    title: '伯克希尔·哈撒韦 CEO',
    quote: '别人贪婪时我恐惧，别人恐惧时我贪婪。',
    quoteEn: 'Be fearful when others are greedy, and greedy when others are fearful.',
    avatar: '🧓',
  },
  {
    id: 'dalio',
    name: '瑞·达利欧',
    nameEn: 'Ray Dalio',
    title: '桥水基金创始人',
    quote: '了解真相，即使真相并不令人愉快，也是一件了不起的事。',
    quoteEn: 'The greatest reward of understanding the truth is that it gives you the ability to deal with reality.',
    avatar: '🎩',
  },
  {
    id: 'munger',
    name: '查理·芒格',
    nameEn: 'Charlie Munger',
    title: '伯克希尔·哈撒韦副董事长',
    quote: '我这一辈子只做一件事——让自己有资格做到这一点：用更低的风险赚到更多的钱。',
    quoteEn: 'All I want to know is where I\'m going to die, so I\'ll never go there.',
    avatar: '📖',
  },
  {
    id: 'graham',
    name: '本杰明·格雷厄姆',
    nameEn: 'Benjamin Graham',
    title: '价值投资之父',
    quote: '投资操作是以深入分析为基础，确保本金安全，并获得适当的回报。',
    quoteEn: 'An investment operation is one which, upon thorough analysis, promises safety of principal and an adequate return.',
    avatar: '🏛️',
  },
  {
    id: 'lynch',
    name: '彼得·林奇',
    nameEn: 'Peter Lynch',
    title: '麦哲伦基金前经理',
    quote: '知道你持有什么，以及为什么持有它。',
    quoteEn: 'Know what you own, and know why you own it.',
    avatar: '📈',
  },
  {
    id: 'soros',
    name: '乔治·索罗斯',
    nameEn: 'George Soros',
    title: '量子基金创始人',
    quote: '我富有仅仅是因为我知道自己什么时候错了。',
    quoteEn: 'I\'m only rich because I know when I\'m wrong.',
    avatar: '🌍',
  },
];

export default function CelebrityQuotes({ lang }) {
  const { t } = useLang();

  return (
    <section className="hp-section">
      <h2 className="hp-section-title">{t('home.celebrityTitle')}</h2>
      <p className="hp-section-desc">{t('home.celebrityDesc')}</p>
      <div className="hp-celebrity-grid">
        {celebrityQuotes(t).map((item) => (
          <div className="hp-celebrity-card" key={item.id}>
            <div className="hp-celebrity-avatar">{item.avatar}</div>
            <blockquote className="hp-celebrity-quote">
              "{lang === 'zh' ? item.quote : item.quoteEn}"
            </blockquote>
            <div className="hp-celebrity-info">
              <div className="hp-celebrity-name">{lang === 'zh' ? item.name : item.nameEn}</div>
              <div className="hp-celebrity-title">{item.title}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
